/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Delete_Toast_Loading_DescInputs */

const es_sidebar_delete_toast_loading_desc = /** @type {(inputs: Sidebar_Delete_Toast_Loading_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperá mientras eliminamos la conversación.`)
};

const en_sidebar_delete_toast_loading_desc = /** @type {(inputs: Sidebar_Delete_Toast_Loading_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while we delete the conversation.`)
};

/**
* | output |
* | --- |
* | "Please wait while we delete the conversation." |
*
* @param {Sidebar_Delete_Toast_Loading_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_toast_loading_desc = /** @type {((inputs?: Sidebar_Delete_Toast_Loading_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Toast_Loading_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_toast_loading_desc(inputs)
	return en_sidebar_delete_toast_loading_desc(inputs)
});
export { sidebar_delete_toast_loading_desc as "sidebar.delete_toast.loading_desc" }